// extracted by mini-css-extract-plugin
export default {"innerWrapper":"iB-z","tooltipWrapper":"jB-z","icon":"kB-z","tooltip":"lB-z","content":"mB-z"};